export default "__VITE_ASSET__DzX_E$Rt__"